export default [
  {
    "id": "123",
    "key": "110kV_HW_SF6_CZS_DLQ_LW49_126_HYDQ",
    "name": "110kV户外SF6瓷柱式断路器_开关",
    //绑定模型
    "model": "110kV_HW_SF6_CZS_DLQ_LW49_126_HYDQ",
    "sign":"",
    "icon":"",
    "type": "设备",
    "spec": "",
    "factory": "",
    "struct": "",
    "theory": "",
    "function": "",
    "extension": [{
      "name": "分合指示标签状态",
      "field": "CZJGX_FHZSBQ_ZT",
      "type": "string/integer/float/enum/bool",
      "range": [
        "0",
        "1"
      ],
      "default": "1",
      "unit": "升",
      "desc": "0为分位,1为合位",
    }],
    "action": {
      "bind_prop": "",
      "name": "滑动",
      //图片、视频、文字反复沟通
      "desc": "",
      "anim_plugin": [{

      }]
    },
  },
  {
    "id": "124",
    "key": "110kV_HW_SF6_CZS_DLQ_LW49_126_HYDQ",
    "name": "110kV户外SF6瓷柱式断路器_开关",
    //绑定模型
    "model": "110kV_HW_SF6_CZS_DLQ_LW49_126_HYDQ",
    "sign":"",
    "icon":"",
    "type": "工具",
    "spec": "",
    "factory": "",
    "struct": "",
    "theory": "",
    "function": "",
    "extension": [{
      "name": "分合指示标签状态",
      "field": "CZJGX_FHZSBQ_ZT",
      "type": "string/integer/float/enum/bool",
      "range": [
        "0",
        "1"
      ],
      "default": "1",
      "unit": "升",
      "desc": "0为分位,1为合位",
    }],
    "action": {
      "bind_prop": "",
      "name": "滑动",
      //图片、视频、文字反复沟通
      "desc": "",
      "anim_plugin": [{

      }]
    },
  }
];